// Route Code Edited 8/13/2026
/**
 * Route Element Attribute Handler
 *
 * Watches for configured elements in the DOM and enforces class and attribute
 * changes via MutationObserver. Re-enforces on any mutation to prevent
 * third-party apps from overwriting Route's element state.
 *
 * Each entry in ELEMENT_CONFIGS targets a selector independently.
 *
 * Installation:
 * Add this script tag at the bottom of layout/theme.liquid (before </body>):
 *
 * <!-- Route Code Edited 07/__/2026 -->
 * <script src="{{ 'route-element-attribute-handler.js' | asset_url }}" defer></script>
 * <!-- End Route Code -->
 */
(function routeElementAttributeHandler() {
  // ─── Configure below ──────────────────────────────────────
  const ELEMENT_CONFIGS = [
    {
      selector: '[data-route-cloned-button]',
      classesToRemove: [
         'ocu-checkout-button',
      ],
      classesToAdd: [
      ],
      attrs: {
      },
    },
  ];
  // ────────────────────────────────────────────────────
  function hasUnwantedState(el, config) {
    return (
      config.classesToRemove.some(c => el.classList.contains(c)) ||
      config.classesToAdd.some(c => !el.classList.contains(c)) ||
      Object.entries(config.attrs).some(([a, v]) =>
        v === null
          ? el.hasAttribute(a)
          : el.getAttribute(a) !== v
      )
    );
  }
  function applyChanges(el, config, observer) {
    observer.disconnect();
    config.classesToRemove.forEach(c => el.classList.remove(c));
    config.classesToAdd.forEach(c => el.classList.add(c));
    Object.entries(config.attrs).forEach(([a, v]) => {
      if (v === null) {
        el.removeAttribute(a);
      } else {
        el.setAttribute(a, v);
      }
    });
    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class', ...Object.keys(config.attrs)],
    });
  }
  function watchElement(el, config) {
    if (el._routeHandlerWatched) return;
    el._routeHandlerWatched = true;
    const observer = new MutationObserver(() => {
      if (hasUnwantedState(el, config)) applyChanges(el, config, observer);
    });
    applyChanges(el, config, observer);
  }
  const domObserver = new MutationObserver(() => {
    ELEMENT_CONFIGS.forEach(config => {
      document.querySelectorAll(config.selector).forEach(el => watchElement(el, config));
    });
  });
  domObserver.observe(document.body, { childList: true, subtree: true });
  ELEMENT_CONFIGS.forEach(config => {
    document.querySelectorAll(config.selector).forEach(el => watchElement(el, config));
  });
  window.addEventListener('pagehide', () => domObserver.disconnect());
})();